<template>
  <div class="ll-state" :class="{ 'mt-lg': isMtLg, 'border-top': borderTop }">
    <div class="ll-state__container">
      <StateInputButton
        v-if="type === 'text' || type === 'number'"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        :title="title"
        :rules="rules"
        :required="isRequired"
        :disabled="isDisabled"
        :btn-text="btnText"
        :btn-icon="btnIcon"
        :text-length="textLength"
        :default-value="defaultValue"
        @input="$_onChange($event)"
        @btn-click="$_btnClick()"
        @enter="$_enterClick()"
      />
      <DropdownSelectMenuButton
        v-else-if="type === 'member'"
        outline
        avatar-select
        :value="value"
        :placeholder="placeholder"
        :title="title"
        :leading-icon="leadingIcon"
        :rules="rules"
        :required="isRequired"
        :model-name="dropdownType"
        :has-check-box="hasCheckBox"
        :is-check-box-select="isCheckBoxSelect"
        :checkbox-text="checkboxText"
        :select-value="selectValue"
        :priority="isPriority"
        :add-text-label="addTextLabel"
        @input="$_onChange($event)"
        @checkbox-select="$_checkBoxSelect($event)"
      />
      <InputTextareaButton
        v-else-if="type === 'textarea'"
        :value="value"
        :min-height="minHeight"
        :placeholder="placeholder"
        :title="title"
        :required="isRequired"
        :rules="rules"
        :max-length="maxLength"
        @input="$_onChange($event)"
      >
        <template v-slot:button>
          <slot name="button" />
        </template>
        <template v-slot:images>
          <slot name="images" />
        </template>
        <template v-slot:attaches>
          <slot name="attaches" />
        </template>
      </InputTextareaButton>
      <StateDatePickerInput
        v-else-if="type === 'date'"
        :value="value"
        :title="title"
        :required="isRequired"
        :rules="rules"
        :leading-icon="leadingIcon"
        @input="$_onChange($event)"
      />
      <SearchInput
        v-else-if="type === 'search'"
        :value="value"
        :title="title"
        :placeholder="placeholder"
        @enter="$_enterClick()"
        @input="$_onChange($event)"
      />
      <StateDropdownSelectClassification
        v-else-if="type === 'multiple-layer-select'"
        :value="value"
        :title="title"
        :menu="menu"
        :required="isRequired"
        :rules="rules"
        :outline="isOutline"
        :all-select-text="allSelectText"
        :placeholder="placeholder"
        @click="$_onClick()"
        @input="$_onChange($event)"
      />
      <DropdownMultipleMemberSelectMenuButton
        v-else-if="type === 'members'"
        outline
        :value="value"
        :title="title"
        :required="isRequired"
        :rules="rules"
        :type="dropdownType"
        :priority="isPriority"
        :select-value="selectValue"
        :leading-icon="leadingIcon"
        :placeholder="placeholder"
        :add-text-label="addTextLabel"
        @input="$_onChange($event)"
      />
      <StatePopupRectangleButton
        v-else-if="type === 'rectangle-button'"
        :title="title"
        :content-text="value"
        :required="isRequired"
        :disabled="isDisabled"
      />
      <DropdownMenuButton
        v-else-if="type === 'dropdown'"
        :title="title"
        :value="value"
        :required="isRequired"
        :disabled="isDisabled"
        :outline="isOutline"
        :dropdown-menu-item="dropdownMenuItems"
        :placeholder="placeholder"
        :remind-text="remindText"
        :before-text="beforeText"
        :after-text="afterText"
        :default-value="defaultValue"
        :disableCancel="disableCancel"
        @input="$_onChange($event)"
        @click="$_onClick()"
      />
      <WsHtmlText v-else-if="type === 'html-text'" :value="textContent" />
      <LvLawPick
        v-else-if="type === 'act-pick'"
        :value="value"
        :title="title"
        @input="$_onChange($event)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'LlState',
  props: {
    value: {},
    selectValue: {},
    borderTop: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    leadingIcon: {
      type: String,
      default: '',
    },
    minHeight: {
      type: Number,
      default: 0,
    },
    dropdownType: {
      type: String,
      default: '',
    },
    hasCheckBox: {
      type: Boolean,
      default: false,
    },
    isCheckBoxSelect: {
      type: Boolean,
      default: false,
    },
    checkboxText: {
      type: String,
      default: '',
    },
    menu: {
      type: Array,
      default() {
        return [];
      },
    },
    isOutline: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: '',
    },
    btnIcon: {
      type: String,
      default: '',
    },
    isMtLg: {
      type: Boolean,
      default: false,
    },
    isPriority: {
      type: Boolean,
      default: false,
    },
    addTextLabel: {
      type: String,
      default: '',
    },
    dropdownMenuItems: {
      type: Array,
      default() {
        return [];
      },
    },
    remindText: {
      type: String,
      default: '',
    },
    beforeText: {
      type: String,
      default: '',
    },
    afterText: {
      type: String,
      default: '',
    },
    textLength: {
      type: String,
      default: '',
    },
    defaultValue: {
      type: [String, Number, Object, Array],
      default: null,
    },
    allSelectText: {
      type: String,
      default: null,
    },
    maxLength: {
      type: [String, Number],
    },
    disableCancel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_onChange($event) {
      this.$emit('input', $event);
    },
    $_onClick() {
      this.$emit('click');
    },
    $_enterClick() {
      this.$emit('enter');
    },
    $_checkBoxSelect($event) {
      this.$emit('checkbox-select', $event);
    },
    $_btnClick() {
      this.$emit('btn-click');
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/ll-state';
</style>
